import styled from '@emotion/styled';
import { palette, theme } from 'theme';
import pxToEm from 'theme/pxToEm';

export const Wrapper = styled.div<{
  show: boolean;
  isFullscreenOpen: boolean;
  backgroundColor?: string;
}>`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: ${({ isFullscreenOpen }) =>
    isFullscreenOpen ? 'static' : 'relative'};
  z-index: 1;

  &:before {
    content: '';
    position: absolute;
    width: 100vw;
    height: 100%;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    background-color: ${({ backgroundColor }) =>
      // @ts-expect-error // TODO: fix types
      backgroundColor || palette.secondary.main};
    z-index: -1;
  }
`;

export const Content = styled.div`
  padding: ${pxToEm(32)} 0;
  min-height: ${pxToEm(385)};
  display: flex;

  ${theme.breakpoints.down('md')} {
    padding: ${pxToEm(24)} 0;
    min-height: ${pxToEm(280)};
    display: block;
  }
`;
